export default "__VITE_ASSET__GyqiEyia__"